import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { brand } from "../mock";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a
        href={brand.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="w-13 h-13 p-3 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 transition-transform"
      >
        <MessageCircle size={22} />
      </a>
      <a
        href={brand.phoneDial}
        aria-label="Call"
        className="w-13 h-13 p-3 rounded-full btn-primary shadow-xl"
      >
        <Phone size={22} />
      </a>
    </div>
  );
}
